module.exports = __webpack_public_path__ + "static/media/pro.425d41a3.svg";